<template>
  <controller :goToTopButton="true">
    <page-header title="Vouchers">
      <template v-slot:side>
        <transition name="slideRightToLeft" mode="out-in">
          <router-link 
            :to="{ name: 'Vouchers' }" 
            class="btn btn-secondary" 
            v-if="section"
            key="btn-voltar"
          >
            <span><fa :icon="['far', 'arrow-left-long']" /> Voltar</span>
          </router-link>

          <div v-else key="btn-home" style="display: flex; gap: 10px;">
            <!-- <router-link 
              :to="{ name: 'Vouchers', params: { section: 'criar'} }" 
              class="btn btn-primary"
            >
              <span>Nova Categoria</span>&nbsp;
              <fa :icon="['fal', 'ticket']" />
            </router-link> -->

            <router-link 
              :to="{ name: 'Vouchers', params: { section: 'financeiro', id: '123', action: 'aprovar' } }" 
              class="btn btn-secondary"
              v-if="approveVoucher"
            >
               Aprovação de vouchers
            </router-link>
          </div>

        </transition>
      </template> 
    </page-header>

    <categorias-voucher v-if="!section" />
    <nova-categoria-voucher v-if="section && !id" />
    <detalhes-voucher :id="id" :section="section" v-if="section && id && !action" />
    <criar-novo-voucher v-if="section && id && action == 'criar'" />
    <aprovar-voucher v-if="section && id && action == 'aprovar'" :id="id" />

  </controller>
</template>

<script>
import CategoriasVoucher from '@/components/financeiro/vouchers/CategoriasVoucher.vue'
import NovaCategoriaVoucher from '@/components/financeiro/vouchers/NovaCategoriaVoucher.vue'
import DetalhesVoucher from '@/components/financeiro/vouchers/DetalhesVoucher.vue'
import CriarNovoVoucher from '@/components/financeiro/vouchers/CriarNovoVoucher.vue'
import AprovarVoucher from '@/components/financeiro/vouchers/AprovarVoucher.vue'
import UserService from '@/services/user.service.js'

export default {
  components: {
    CategoriasVoucher, 
    NovaCategoriaVoucher, 
    DetalhesVoucher, 
    CriarNovoVoucher, 
    AprovarVoucher
  },
  props: {
    section: { type: String },
    id: { type: [String, Number] },
    action: { type: String }
  },
  data () {
    return {
      approveVoucher: false
    }
  },
  mounted () {
    this.approveVoucher = UserService.filterPermissions('approveVoucher')
  }
}
</script>